export const STATUS_SESSION = {
  NOTBOUGHT_NOTFINISH_NOTHAPPEN: 'status_session_one', // chưa mua, chưa kết thúc, chưa diễn ra
  BOUGHT_NOTHAPPEN: 'status_session_two', // đã mua, nhưng chưa diễn ra
  BOUGHT_AND_HAPPEN: 'status_session_three', // đã mua và đang diễn ra
  BOUGHT_FINISHED: 'status_session_four', // đã mua và đã kết thúc
  NOTBOUGHT_FINISHED: 'status_session_five' // chưa mua và kết thúc
}
